import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./mobile-nav-card.module.css";
import { ArrowRight } from "../../../assets/arrow-right";
export var MobileNavCard = function(param) {
    var heading = param.heading, link = param.link, href = param.href, imageSrc = param.imageSrc, alt = param.alt, handleTrackEvent = param.handleTrackEvent;
    return /*#__PURE__*/ _jsxs("li", {
        className: styles.navCard,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.textContainer,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: styles.heading,
                        children: heading
                    }),
                    /*#__PURE__*/ _jsxs("a", {
                        href: href,
                        className: styles.link,
                        onClick: handleTrackEvent,
                        children: [
                            link,
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.icon,
                                children: /*#__PURE__*/ _jsx(ArrowRight, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.imageWrapper,
                children: /*#__PURE__*/ _jsx("img", {
                    src: imageSrc,
                    alt: "".concat(alt, " mobile"),
                    className: styles.image
                })
            })
        ]
    });
};
